import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useData } from '../hooks/useData';

const ResearchPage = () => {
  const { data: researchData, loading, error } = useData('research.json');

  if (loading) return <div className="container mx-auto p-4 text-center">Loading research articles...</div>;
  if (error) return <div className="container mx-auto p-4 text-center text-red-500">Error loading research articles: {error}</div>;
  if (!researchData || !researchData.articles) return <div className="container mx-auto p-4 text-center">No research articles found.</div>;

  const articles = researchData.articles;

  return (
    <>
      <Helmet>
        <title>AI Research - AI News</title>
        <meta name="description" content="Explore the latest AI research papers, breakthroughs, and conference updates." />
        <meta name="keywords" content="AI research, machine learning papers, AI breakthroughs, AI conferences" />
      </Helmet>
      <div className="container mx-auto p-4">
        <header className="my-8 text-center">
          <h1 className="text-4xl font-bold text-gray-100">AI Research</h1>
          <p className="text-lg text-gray-300 mt-2">Stay updated with the latest advancements in AI research.</p>
        </header>
        
        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <article key={article.id} className="card hover:shadow-xl transition-shadow">
              <div className="mb-4">
                <span className="text-secondary-blue font-semibold">{article.category}</span>
                <span className="text-gray-400 ml-2">{article.date}</span>
              </div>
              <h2 className="text-xl font-bold mb-2 text-gray-100">{article.title}</h2>
              <p className="text-gray-300 mb-4 text-sm">{article.summary}</p>
              {article.authors && (
                <p className="text-xs text-gray-400 mb-2">Authors: {article.authors.join(', ')}</p>
              )}
              <Link
                to={`/research/${article.slug}`}
                className="text-secondary-blue font-semibold hover:underline text-sm"
              >
                Read More →
              </Link>
            </article>
          ))}
        </section>
      </div>
    </>
  );
};

export default ResearchPage; 